import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { LatLngLiteral } from "leaflet";
import { FiCamera, FiX, FiCheck } from "react-icons/fi";

import { typeProduction } from "../../data";
import { createProperty } from "../../../../services/property";
import AttachFile from "../../../../assets/svg/AttachFile";
import { Input } from "../../../../components/Input";
import {
  Container,
  Form,
  ContentButton,
  SectionForm,
  InputMap,
  FirstContentForm,
  SecondContentForm,
  PictureProperty,
  PicturePreview,
  ControlsUploadImage,
  RemovePicture,
  NoPicturePreview,
  LatLng,
  UploadSanitaryPlan,
} from "./styles";
import { ICity, ICreateProperty, IState } from "../../interfaces";
import { Button } from "../../../../components/Button";
import { useNotification } from "../../../../hooks/useNotification";
import { SelectInput } from "../../../../components/SelectInput";
import { HeaderTitle } from "../../../../components/HeaderTitle";
import { Map } from "../../../../components/Map";
import { OptionSelect, TypeMask } from "../../../../common/interfaces";
import { insertMask } from "../../../../utils/mask";
import { loadCities, loadStates } from "../../../../services/mesoregion";
import { useAuth } from "../../../../hooks/useAuth";
import { useTranslate } from "../../../../hooks/useTranslate";
import { getAddressByLatLog } from "../../../../helpers/address";

const CreateProperty = () => {
  const { errorNotification, successNotification } = useNotification();
  const navigate = useNavigate();
  const { propertiesIds, user } = useAuth();
  const { translate, currentLanguage } = useTranslate();

  const schema = yup.object().shape({
    name: yup.string().required(translate("property.name_property_required")),
    hectares: yup.string().required(translate("property.hectares_required")),
    areaDairyActivity: yup.string(),
    // .required(translate("property.area_dairy_required")),
    mediumHerdSize: yup.string(),
    // .required(translate("property.herd_size_reqired")),
    cnpj: yup.string(),
    // .required(translate("property.cnpj_reqired")),
    numberProducerRural: yup.string(),
    // .required(translate("property.producer_rural_required")),
    city: yup.string().nullable().required(translate("property.city_required")),
    state: yup
      .string()
      .nullable()
      .required(translate("property.state_required")),
    country: yup.string().required(translate("property.country_required")),
    routeDescription: yup.string(),
    // .required(translate("property.route_description_required")),
    typeProduction: yup.object().shape({
      label: yup.string(),
      // .required(translate("property.type_production_required")),
      value: yup.string(),
      // .required(translate("property.type_production_required")),
    }),
    latitude: yup
      .string()
      .required(translate("property.position_map_required")),
    longitude: yup
      .string()
      .required(translate("property.position_map_required")),
    nameVeterinary: yup.string(),
    // .required(translate("property.name_veterinary_required")),
  });

  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    getValues,
    formState: { errors },
  } = useForm<ICreateProperty>({
    resolver: yupResolver(schema),
  });

  const [preImage, setPreImage] = useState<File | string>("");
  const [image, setImage] = useState<File | string>("");
  const [sanitaryPlan, setSanitaryPlan] = useState<File | string>("");
  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState<OptionSelect[]>([]);
  const [cities, setCities] = useState<OptionSelect[]>([]);
  const [coordinates, setCoordinates] = useState<LatLngLiteral>({
    lat: 0,
    lng: 0,
  } as LatLngLiteral);

  const submitForm = async (data: ICreateProperty) => {
    // if (!image) return errorNotification(translate("property.image_required"));

    // if (!sanitaryPlan)
    //   return errorNotification(translate("property.sanitary_plan_required"));

    const {
      name,
      hectares,
      areaDairyActivity,
      mediumHerdSize,
      // cnpj,
      numberProducerRural,
      city,
      state,
      country,
      routeDescription,
      typeProduction,
      latitude,
      longitude,
      nameVeterinary,
    } = data;

    try {
      setLoading(true);

      const form = new FormData();
      form.append("name", name);

      form.append("idUser", user.id);
      form.append("typeUser", user.type);

      form.append("name", name);
      form.append("hectares", hectares);
      form.append("city", city);
      form.append("state", state);
      form.append("latitude", latitude);
      form.append("longitude", longitude);
      form.append("country", country);

      if (areaDairyActivity) {
        form.append("areaDairyActivity", areaDairyActivity);
      }
      if (mediumHerdSize) {
        form.append("mediumHerdSize", mediumHerdSize);
      }
      if (numberProducerRural) {
        form.append("numberProducerRural", numberProducerRural);
      }
      if (routeDescription) {
        form.append("routeDescription", routeDescription);
      }
      if (typeProduction.value) {
        form.append("typeProduction", typeProduction.value);
      }
      if (image) {
        form.append("photo", image);
      }
      if (sanitaryPlan) {
        form.append("sanitaryPlan", sanitaryPlan);
      }
      if (nameVeterinary) {
        form.append("nameVeterinary", nameVeterinary);
      }

      await createProperty(form);
      setLoading(false);
      successNotification(translate("property.success_message"));
      navigate("/properties");
    } catch (error) {
      errorNotification(translate("property.error_message"));
      setLoading(false);
    }
  };

  // const handleMask = (value: string, mask: TypeMask) => {
  //   const valueFormatted = insertMask(value, mask);
  //   setValue("cnpj", valueFormatted);
  // };

  const setLocationInForm = async ({ lat, lng }: LatLngLiteral) => {
    if (lat && lng) {
      const { city, state } = await getAddressByLatLog(`${lat}`, `${lng}`);

      setValue("latitude", String(lat));
      setValue("longitude", String(lng));
      setValue("state", state as any);
      setValue("city", city as any);

      setCoordinates({ lat, lng });
    }

    // const s = states.find((s) => s.value === state);
    // const c = cities.find((s) => s.value === city);
  };

  const submitFile = (file: FileList | null) => {
    if (file == null) return;

    thePreviewImage(file[0]);
    setImage(file[0]);
  };

  const thePreviewImage = (file: File) => {
    setPreImage(URL.createObjectURL(file));
  };

  const getSanitaryPlanFile = (file: FileList | null) => {
    if (file == null) return;

    setSanitaryPlan(file[0]);
  };

  const loadStatesByCountry = async (country: string) => {
    try {
      const states: IState[] = await loadStates(country);
      const statesFormatted = states.map(({ state, initials }) => ({
        label: state,
        value: initials,
      }));
      setStates(statesFormatted);
    } catch (error) {
      errorNotification(translate("property.error_load_states"));
    }
  };

  const loadCitiesByState = async () => {
    try {
      const state = getValues("state");

      if (!state) return;

      const cities: ICity[] = await loadCities(state);

      const citiesFormatted = cities.map(({ municipio }) => ({
        label: municipio,
        value: municipio,
      }));
      setCities(citiesFormatted);
    } catch (error) {
      errorNotification(translate("property.error_load_cities"));
    }
  };

  useEffect(() => {
    // if (propertiesIds.length > 0) {
    //   navigate("/properties");
    //   return;
    // }
    const country = "BR";
    setValue("country", country);
    // loadStatesByCountry(country);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        setLocationInForm({ lat: latitude, lng: longitude });
      },
      () => {
        setLocationInForm({ lat: -23.982843995311182, lng: -48.8800575058413 });
      }
    );
  }, [propertiesIds]);

  // useEffect(() => {
  //   // loadCitiesByState();
  // }, [watch("state"), getValues]);

  return (
    <Container>
      <HeaderTitle
        title={translate("property.title_new")}
        url="/properties"
        showIcon
      />
      <Form onSubmit={handleSubmit(submitForm)}>
        <SectionForm>
          <p>{translate("property.data_property")}</p>
          <FirstContentForm>
            <Input
              {...register("name")}
              error={errors.name?.message}
              placeholder={translate("property.name_property")}
              type="text"
            />
            <Input
              {...register("hectares")}
              error={errors.hectares?.message}
              placeholder={translate("property.placeholder_hectares")}
              type="number"
            />
            <Input
              {...register("areaDairyActivity")}
              error={errors.areaDairyActivity?.message}
              placeholder={translate("property.placeholder_area_dairy")}
              type="number"
            />
            <Input
              {...register("mediumHerdSize")}
              error={errors.mediumHerdSize?.message}
              placeholder={translate("property.placeholder_herd_size")}
              type="number"
            />
            <Controller
              name="typeProduction"
              control={control}
              render={({ field }) => (
                <SelectInput
                  {...field}
                  options={typeProduction.map((t) => ({
                    ...t,
                    label: t.label?.[currentLanguage.code] ?? "pt-br",
                  }))}
                  placeholder={translate(
                    "property.placeholder_type_production"
                  )}
                  error={errors.typeProduction?.label?.message}
                />
              )}
            />
            {/* <Input
              {...register("cnpj")}
              error={errors.cnpj?.message}
              placeholder={translate("property.placeholder_cnpj")}
              onChange={(e) => {
                handleMask(e.target.value, "cnpj");
              }}
              type="text"
            /> */}
            <Input
              {...register("numberProducerRural")}
              error={errors.numberProducerRural?.message}
              placeholder={translate("property.placeholder_producer_rural")}
              type="text"
            />
            <Input
              {...register("routeDescription")}
              error={errors.routeDescription?.message}
              placeholder={translate("property.placeholder_route_description")}
              type="text"
            />
            <InputMap>
              {coordinates.lat !== 0 && coordinates.lng !== 0 && (
                <Map
                  coordinates={coordinates}
                  getPosition={setLocationInForm}
                  scrollWheelZoom
                  zoom={15}
                />
              )}
            </InputMap>
            <PictureProperty>
              {preImage ? (
                <PicturePreview>
                  <img src={String(preImage)} alt="Property" />
                </PicturePreview>
              ) : (
                <NoPicturePreview>
                  <FiCamera />
                  <p>{translate("property.photo_farmer")}</p>
                </NoPicturePreview>
              )}
              <ControlsUploadImage>
                <div>
                  <label htmlFor="upload-file">
                    {translate("property.select_image")}
                  </label>
                  <input
                    onChange={(e) => {
                      submitFile(e.target.files);
                      e.target.value = "";
                    }}
                    accept="image/*"
                    id="upload-file"
                    type="file"
                  />
                </div>
                {preImage && (
                  <RemovePicture>
                    <FiX
                      onClick={() => {
                        setPreImage("");
                        setImage("");
                      }}
                    />
                  </RemovePicture>
                )}
              </ControlsUploadImage>
            </PictureProperty>
            {/* <LatLng>
              <Input
                {...register("latitude")}
                error={errors.latitude?.message}
                placeholder={translate("property.placeholder_lat")}
                disabled
                type="text"
              />
              <Input
                {...register("longitude")}
                error={errors.longitude?.message}
                placeholder={translate("property.placeholder_long")}
                disabled
                type="text"
              />
            </LatLng> */}
            <Input
              {...register("city")}
              error={errors.city?.message}
              placeholder={translate("property.placeholder_city")}
              disabled
              type="text"
            />

            <Input
              {...register("state")}
              error={errors.state?.message}
              placeholder={translate("property.placeholder_state")}
              disabled
              type="text"
            />
            <Input
              {...register("country")}
              error={errors.country?.message}
              placeholder={translate("property.placeholder_country")}
              disabled
              type="text"
            />
          </FirstContentForm>
        </SectionForm>
        {/* <SectionForm>
          <p>{translate("property.production_milk")}</p>
          <SecondContentForm>
            <UploadSanitaryPlan selectedFile={!!sanitaryPlan}>
              <label htmlFor="upload-sanitary-plan">
                {translate("property.sanitary_plan")}
                {sanitaryPlan ? <FiCheck /> : <AttachFile />}
              </label>
              <input
                onChange={(e) => {
                  getSanitaryPlanFile(e.target.files);
                  e.target.value = "";
                }}
                accept="application/pdf"
                id="upload-sanitary-plan"
                type="file"
              />
            </UploadSanitaryPlan>
            <Input
              {...register("nameVeterinary")}
              error={errors.nameVeterinary?.message}
              placeholder={translate("property.name_veterinary")}
              type="text"
            />
          </SecondContentForm>
        </SectionForm> */}
        <ContentButton>
          <Button
            isLoading={loading}
            type="submit"
            label={translate("property.label_btn_new")}
          />
        </ContentButton>
      </Form>
    </Container>
  );
};

export { CreateProperty };
